import { render, staticRenderFns } from "./daily-cargo-data-edit.vue?vue&type=template&id=da6ad25a"
import script from "./daily-cargo-data-edit.vue?vue&type=script&lang=js"
export * from "./daily-cargo-data-edit.vue?vue&type=script&lang=js"
import style0 from "./daily-cargo-data-edit.vue?vue&type=style&index=0&id=da6ad25a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports